module.exports = __webpack_public_path__ + "static/media/tmc-mobile-app.6834bbd3.png";